import { AppPermissions } from '@/utils/permissions';

export const routeNames = {
  // Billing routes
  ADMIN_BILLING: {
    name: 'ADMIN_BILLING',
    uiLabel: 'Billing',
  },
  ADMIN_BILLING_BILLS: {
    name: 'ADMIN_BILLING_BILLS',
    uiLabel: 'Bills',
  },
  ADMIN_BILLING_DETAIL: {
    name: 'ADMIN_BILLING_DETAIL',
    uiLabel: 'Bill Detail',
  },
  ADMIN_BILLING_STUDENTS: {
    name: 'ADMIN_BILLING_STUDENTS',
    uiLabel: 'Bill Students',
  },
  ADMIN_BILLING_ITEMS: {
    name: 'ADMIN_BILLING_ITEMS',
    uiLabel: 'Fee Items',
  },
  ADMIN_BILLING_TRANSACTIONS: {
    name: 'ADMIN_BILLING_TRANSACTIONS',
    uiLabel: 'Payments',
  },
  ADMIN_BILLING_FORM_FEES: {
    name: 'ADMIN_BILLING_FORM_FEES',
    uiLabel: 'Form Fees',
  },
  ADMIN_BILLING_WAIVER_CODES: {
    name: 'ADMIN_BILLING_WAIVER_CODES',
    uiLabel: 'Waiver Codes',
  },
  ADMIN_BILLING_DEBTORS: {
    name: 'ADMIN_BILLING_DEBTORS',
    uiLabel: 'Debtors',
  },
  ADMIN_BILLING_DISCOUNTS: {
    name: 'ADMIN_BILLING_DISCOUNTS',
    uiLabel: 'Discounts',
  },
  ADMIN_BILLING_DISCOUNT_DETAIL: {
    name: 'ADMIN_BILLING_DISCOUNT_DETAIL',
    uiLabel: 'Discount Detail',
  },
  ADMIN_BILLING_DASHBOARD: {
    name: 'ADMIN_BILLING_DASHBOARD',
    uiLabel: 'Dashboard',
  },
  ADMIN_BILLING_REPORTS: {
    name: 'ADMIN_BILLING_REPORTS',
    uiLabel: 'Reports',
  },
  ADMIN_BILLING_REFUNDS: {
    name: 'ADMIN_BILLING_REFUNDS',
    uiLabel: 'Refunds & Exemptions',
  },
  ADMIN_BILLING_STUDENT_FINANCIALS: {
    name: 'ADMIN_BILLING_STUDENT_FINANCIALS',
    uiLabel: 'Student Financials',
  },
  ADMIN_BILLING_STUDENT_DIRECTORY: {
    name: 'ADMIN_BILLING_STUDENT_DIRECTORY',
    uiLabel: 'Students',
  },
  CBT_GRADING: {
    name: 'CBT_GRADING',
    uiLabel: 'CBT Grading',
  },
  ADMIN_CERTIFICATES: {
    name: 'admin-certificates',
    uiLabel: 'Certificates',
  },
};

export interface MenuItem {
  routeName: string
  tooltipText: string
  menuText: string
  menuIcon: string
  showFor: 'all' | 'tertiary' | 'non-tertiary' | 'parent'
  path: string
  permission?: { action: string, resource: string }
  permissions?: { action: string, resource: string }[]
}

export const menubarItems: MenuItem[] = [
  {
    routeName: 'admin-home',
    tooltipText: 'Dashboard',
    menuText: 'Dashboard',
    menuIcon: 'pi-home',
    showFor: 'all',
    path: '/admin/home',
  },
  {
    routeName: 'admin-my-account',
    tooltipText: 'My Account',
    menuText: 'My Account',
    menuIcon: 'pi-user',
    showFor: 'all',
    path: '/admin/my-account',
  },
  {
    routeName: 'admin-my-courses',
    tooltipText: 'My Courses',
    menuText: 'My Courses',
    menuIcon: 'pi-bookmark',
    showFor: 'tertiary',
    path: '/admin/my-courses',
    permission: { action: AppPermissions.LecturerCourseAllocation.Actions.Create, resource: AppPermissions.LecturerCourseAllocation.Resource },
  },
  {
    routeName: 'admin-my-subjects',
    tooltipText: 'My Subjects',
    menuText: 'My Subjects',
    menuIcon: 'pi-book',
    showFor: 'non-tertiary',
    path: '/admin/my-subjects',
  },
  {
    routeName: 'admin-grade-system',
    tooltipText: 'Grade System',
    menuText: 'Grade System',
    menuIcon: 'pi-star',
    showFor: 'all',
    path: '/admin/grade',
    permission: { action: AppPermissions.GradeSystem.Actions.View, resource: AppPermissions.GradeSystem.Resource },
  },
  {
    routeName: 'admin-announcements',
    tooltipText: 'Announcements',
    menuText: 'Announcements',
    menuIcon: 'pi-megaphone',
    showFor: 'all',
    path: '/admin/announcements',
    permission: {
      action: AppPermissions.SchoolAnnouncements.Actions.View,
      resource: AppPermissions.SchoolAnnouncements.Resource,
    },
  },
  {
    routeName: 'admin-student',
    tooltipText: 'Students',
    menuText: 'Students',
    menuIcon: 'pi-users',
    showFor: 'all',
    path: '/admin/student',
    permission: { action: AppPermissions.Students.Actions.View, resource: AppPermissions.Students.Resource },
  },
  {
    routeName: 'admin-reports-center',
    tooltipText: 'Reports Center',
    menuText: 'Reports Center',
    menuIcon: 'pi-chart-line',
    showFor: 'all',
    path: '/admin/reports',
  },
  {
    routeName: 'admin-student-reports',
    tooltipText: 'Student Reports',
    menuText: 'Student Reports',
    menuIcon: 'pi-chart-bar',
    showFor: 'all',
    path: '/admin/reports/students',
    permission: { action: AppPermissions.Students.Actions.View, resource: AppPermissions.Students.Resource },
  },
  {
    routeName: 'admin-cbt',
    tooltipText: 'CBT',
    menuText: 'CBT',
    menuIcon: 'pi-pencil',
    showFor: 'all',
    path: '/admin/cbt',
    permission: { action: AppPermissions.CBT.Actions.View, resource: AppPermissions.CBT.Resource },
  },
  {
    routeName: 'admin-teacher',
    tooltipText: 'Staff',
    menuText: 'Staff',
    menuIcon: 'pi-users',
    showFor: 'all',
    path: '/admin/teacher',
    permission: { action: AppPermissions.Teachers.Actions.View, resource: AppPermissions.Teachers.Resource },
  },
  {
    routeName: 'Subjects',
    tooltipText: 'Subjects',
    menuText: 'Subjects',
    menuIcon: 'pi-book',
    showFor: 'non-tertiary',
    path: '/admin/subjects',
    permission: { action: AppPermissions.Subjects.Actions.View, resource: AppPermissions.Subjects.Resource },
  },
  {
    routeName: 'SubjectOfferings',
    tooltipText: 'Subject Offerings',
    menuText: 'Subject Offerings',
    menuIcon: 'pi-sitemap',
    showFor: 'non-tertiary',
    path: '/admin/subject-offerings',
    permission: { action: AppPermissions.Subjects.Actions.Update, resource: AppPermissions.Subjects.Resource },
  },
  {
    routeName: 'SchemesOfWork',
    tooltipText: 'Schemes of Work',
    menuText: 'Schemes of Work',
    menuIcon: 'pi-list-check',
    showFor: 'non-tertiary',
    path: '/admin/schemes-of-work',
    permission: { action: AppPermissions.SchemeOfWork.Actions.View, resource: AppPermissions.SchemeOfWork.Resource },
  },
  {
    routeName: 'LessonNotes',
    tooltipText: 'Lesson Notes',
    menuText: 'Lesson Notes',
    menuIcon: 'pi-file-edit',
    showFor: 'non-tertiary',
    path: '/admin/lesson-notes',
    permission: { action: AppPermissions.LessonNotes.Actions.View, resource: AppPermissions.LessonNotes.Resource },
  },
  {
    routeName: 'Guardians',
    tooltipText: 'Guardians',
    menuText: 'Guardians',
    menuIcon: 'pi-users',
    showFor: 'all',
    path: '/admin/guardians',
    permission: { action: AppPermissions.Guardians.Actions.View, resource: AppPermissions.Guardians.Resource },
  },
  {
    routeName: 'admin-course',
    tooltipText: 'Courses Manager',
    menuText: 'Courses Manager',
    menuIcon: 'pi-book',
    showFor: 'tertiary',
    path: '/admin/course',
    permissions: [
      { action: AppPermissions.Registrations.Actions.View, resource: AppPermissions.Registrations.Resource },
      { action: AppPermissions.CourseRegistrationApproval.Actions.View, resource: AppPermissions.CourseRegistrationApproval.Resource },
      { action: AppPermissions.CourseRegistrationApproval.Actions.Approve, resource: AppPermissions.CourseRegistrationApproval.Resource },
      { action: AppPermissions.CourseRegistrationApproval.Actions.Endorse, resource: AppPermissions.CourseRegistrationApproval.Resource },
      { action: AppPermissions.CourseExemptions.Actions.View, resource: AppPermissions.CourseExemptions.Resource },
      { action: AppPermissions.CourseEquivalence.Actions.View, resource: AppPermissions.CourseEquivalence.Resource },
    ],
  },
  {
    routeName: 'admin-timetable',
    tooltipText: 'Timetable',
    menuText: 'Timetable',
    menuIcon: 'pi-calendar',
    showFor: 'all',
    path: '/admin/timetable',
    permission: { action: AppPermissions.TimeTable.Actions.View, resource: AppPermissions.TimeTable.Resource },
  },
  {
    routeName: 'admin-results',
    tooltipText: 'Results',
    menuText: 'Results',
    menuIcon: 'pi-chart-bar',
    showFor: 'all',
    path: '/admin/results',
    permission: { action: AppPermissions.Results.Actions.View, resource: AppPermissions.Results.Resource },
  },
  {
    routeName: 'admin-daily-attendance',
    tooltipText: 'Daily Attendance',
    menuText: 'Daily Attendance',
    menuIcon: 'pi-calendar-plus',
    showFor: 'all',
    path: '/admin/attendance/daily',
    permission: { action: AppPermissions.Attendance.Actions.View, resource: AppPermissions.Attendance.Resource },
  },
  {
    routeName: 'admin-attendance-events',
    tooltipText: 'Attendance Events',
    menuText: 'Attendance Events',
    menuIcon: 'pi-flag',
    showFor: 'all',
    path: '/admin/attendance/events',
    permission: { action: AppPermissions.AttendanceEvents.Actions.View, resource: AppPermissions.AttendanceEvents.Resource },
  },
  {
    routeName: 'admin-eclass',
    tooltipText: 'E-Class',
    menuText: 'E-Class',
    menuIcon: 'pi-desktop',
    showFor: 'all',
    path: '/admin/e-class',
    permission: { action: AppPermissions.CBT.Actions.View, resource: AppPermissions.CBT.Resource },
  },
  {
    routeName: 'admin-chat',
    tooltipText: 'Chat',
    menuText: 'Chat',
    menuIcon: 'pi-comments',
    showFor: 'all',
    path: '/admin/chat',
    permission: { action: AppPermissions.Chat.Actions.View, resource: AppPermissions.Chat.Resource },
  },
  {
    routeName: 'admin-parent-dashboard',
    tooltipText: 'Child Schools',
    menuText: 'Child Schools',
    menuIcon: 'pi-sitemap',
    showFor: 'parent',
    path: '/admin/parent-dashboard',
    permission: { action: AppPermissions.ChildSchools.Actions.View, resource: AppPermissions.ChildSchools.Resource },
  },
];

// Student menu items
export const studentMenuItems = [
  {
    routeName: 'student-home',
    tooltipText: 'Dashboard',
    menuText: 'Dashboard',
    menuIcon: 'pi-home',
    path: '/student/home',
  },
  {
    routeName: 'student-courses',
    tooltipText: 'Courses',
    menuText: 'Courses',
    menuIcon: 'pi-book',
    showFor: 'tertiary',
    path: '/student/courses',
  },
  {
    routeName: 'student-timetable',
    tooltipText: 'Timetable',
    menuText: 'Timetable',
    menuIcon: 'pi-calendar',
    path: '/student/timetable',
  },

  {
    routeName: 'student-notice-board',
    tooltipText: 'Notice board',
    menuText: 'Notice board',
    menuIcon: 'pi-megaphone',
    path: '/student/notices',
  },
  {
    routeName: 'student-cbt',
    tooltipText: 'CBT',
    menuText: 'CBT',
    menuIcon: 'pi-pencil',
    path: '/student/cbt',
  },
  {
    routeName: 'student-billing',
    tooltipText: 'Billing',
    menuText: 'Billing',
    menuIcon: 'pi-wallet',
    path: '/student/billing',
  },
  {
    // Payment history was only reachable through a button inside the billing
    // page; students who never pressed it concluded their payments were lost.
    routeName: 'student-payment-history',
    tooltipText: 'Payments',
    menuText: 'Payments',
    menuIcon: 'pi-money-bill',
    path: '/student/billing/payments',
  },
  {
    routeName: 'student-result',
    tooltipText: 'Results',
    menuText: 'Results',
    menuIcon: 'pi-chart-bar',
    path: '/student/result',
  },
  {
    routeName: 'student-transcripts',
    tooltipText: 'Transcripts',
    menuText: 'Transcripts',
    menuIcon: 'pi-file',
    showFor: 'tertiary',
    path: '/student/transcripts',
  },
  {
    routeName: 'student-forms',
    tooltipText: 'Forms',
    menuText: 'Forms',
    menuIcon: 'pi-file-edit',
    path: '/student/forms',
  },
  {
    routeName: 'student-tickets',
    tooltipText: 'Support',
    menuText: 'Support',
    menuIcon: 'pi-comments',
    path: '/student/tickets',
  },
  {
    routeName: 'student-settings',
    tooltipText: 'Settings',
    menuText: 'Settings',
    menuIcon: 'pi-cog',
    path: '/student/settings',
  },
];
